import { Tag, tailwindOverride } from '@getsynapse/design-system';
import classnames from 'classnames';
import intl from 'react-intl-universal';
import { BudgetStatus } from '../../../utils/customTypes';

export const getStatusStyle: (
  status: BudgetStatus,
  selected?: boolean
) => { className: string; textClassName: string } = (
  status,
  selected = false
) => {
  switch (status) {
    case BudgetStatus.ACTIVE:
      return {
        className: classnames(
          'bg-success-lightest group-hover:border-success-dark',
          { 'border-success-dark': selected }
        ),
        textClassName: 'text-success-darker',
      };
    case BudgetStatus.DRAFT:
      return {
        className: classnames('bg-teal-lightest group-hover:border-teal', {
          'border-teal': selected,
        }),
        textClassName: 'text-teal-dark',
      };
    case BudgetStatus.ARCHIVED:
      return {
        className: classnames(
          'bg-neutral-lighter-two group-hover:border-neutral',
          { 'border-neutral-light': selected }
        ),
        textClassName: 'text-neutral-dark',
      };
    default:
      return { className: '', textClassName: '' };
  }
};

export const getStatusColumn = (
  status: BudgetStatus,
  selected?: boolean,
  className?: string
) => {
  if (!status) {
    return null;
  }
  const tagStyle = getStatusStyle(status, selected);
  const tagLabel = getStatusLabel(status);
  return (
    <Tag
      className={tailwindOverride(
        `text-xs border border-transparent py-0.5 ${tagStyle.className} ${className}`
      )}
      textClassName={tagStyle.textClassName}
      label={tagLabel}
    />
  );
};

export const getStatusLabel: (status: BudgetStatus) => string = (status) => {
  const key = `${status}`.toUpperCase();
  return intl.get(`BUDGET_PAGE.STATUS_OPTIONS.${key}`).defaultMessage('');
};
